import { AbstractFigure } from "./AbstractFigure.js";
class Figure extends AbstractFigure {
  /**
   * Config.
   */
  static config = {
    ...AbstractFigure.config,
    name: "Figure"
  };
  /**
   * Terminate the component on load.
   */
  onLoad() {
    this.$terminate();
  }
}
export {
  Figure
};
//# sourceMappingURL=Figure.js.map
